module.exports = __webpack_public_path__ + "static/media/InstalarAccesoNube.88b38107.exe";